<form>
    <div class="title-outer">
        <h2 class="form-title">{{ languageService.languageJSON.ComponentList_Title }}</h2>
    </div>

    <div class="form-section-function">
        <div class="flex-col">
            <div class="flex-row">
                <app-multiple-search [searchFields]="componentFields" [searchByList]="searchByList"
                    (searchByListChange)="onSearchChanged($event)">
                </app-multiple-search>
                <div class="row-to-right" *ngIf="hasComponentEditRole()">
                    <button type="button" routerLink="/component-variant">
                        {{ languageService.languageJSON.ComponentVariant_Title }}</button>
                </div>
            </div>
            <div class="flex-row">
                <app-search-badge [searchByList]="searchByList" [listFields]="componentFields"
                    (searchByListChange)="onSearchChanged($event)"></app-search-badge>
            </div>
        </div>
    </div>

    <div class="form-section table">
        <div class="flex-outer flex-column table">
            <div class="flex-row header">
                <div class="flex-col" [ngClass]="{'medium-col': componentField.Id==0 || componentField.Id==1, 'clickable':componentField.GroupBy, 
                    'bold':order==componentField.FieldName}" *ngFor="let componentField of componentFields"
                    (click)="setOrder(componentField.FieldName, componentField.GroupBy)">
                    {{ componentField.DisplayName }}
                    <span class="order-icon" *ngIf="order==componentField.FieldName && !reverse">▼</span>
                    <span class="order-icon" *ngIf="order==componentField.FieldName && reverse">▲</span>
                </div>
                <div class="flex-col">{{ languageService.languageJSON.ComponentVariant_Variants }}</div>
            </div>
            <ng-scrollbar [orientation]="'vertical'">
                <div class="flex-row" *ngFor="let component of componentList | multipleSearchProperty : searchByList
            | orderBy: order: reverse | paginate: { itemsPerPage: itemsPerPage, currentPage: page}">
                    <div class="flex-col"
                        [ngClass]="{'medium-col': componentField.Id==0 || componentField.Id==1, 'uppercase': componentField.Uppercase}"
                        *ngFor="let componentField of componentFields">
                        {{ component[componentField.FieldName] }}
                    </div>
                    <div class="flex-col">
                        <a [matTooltip]="getVariantTooltipText(component.Variants)" matTooltipClass="configtool-tooltip">
                            {{ component.Variants.length }} {{ languageService.languageJSON.ComponentVariant_Variant }}
                        </a>
                    </div>
                </div>
                <div class="flex-row"
                    *ngIf="(componentList | multipleSearchProperty : searchByList).length==0 && !loading">
                    <div class="flex-col" *ngIf="!hasAnySearchElement()">{{ languageService.languageJSON.Global_NoItems
                        }}</div>
                    <div class="flex-col" *ngIf="hasAnySearchElement()">{{ languageService.languageJSON.Global_NoResult
                        }}</div>
                </div>
            </ng-scrollbar>
            <app-loading-animation *ngIf="loading"></app-loading-animation>
        </div>
    </div>
    <div class="pagination" *ngIf="!loading">
        <div class="pagination-text">{{ getPaginationText() }}</div>
        <pagination-controls (pageChange)="onPageChangeEvent($event)"></pagination-controls>
    </div>
</form>